import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: '',
    assetsData: null,
    selectdGrid: 0
  },
  mutations: {
    updateTitle: function (state, title) {
      state.title = title
    },
    updateAssetData: function (state, data) {
      state.assetsData = data
    },
    updateGrid: function (state, data) {
      state.selectdGrid = data
    }
  },
  actions: {
    updateTitle (context, value) {
      context.commit('updateTitle', value)
    },
    updateAssetsData (context, value) {
      context.commit('updateAssetData', value)
    },
    updateGrid: function (context, value) {
      context.commit('updateGrid', value)
    }
  },
  modules: {
  }
})
